export default [{
  path: '/reports-attendance/goal',
  name: 'reports-attendance-goal',
  component: () => import('@/views/apps/reports-attendance/goal/index.vue'),
},
{
  path: '/reports-dynamic/:id',
  name: 'reports-dynamic-view',
  component: () => import('@/views/apps/reports/report-dynamic.vue'),
}]